import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  skeletonWrapper: {
    marginTop: "24px",
    width: "100%",
    display: "grid",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: 0,
      width: "100%",
    },
    [`@media (min-width: ${breakpoints.xxl}px)`]: {
      width: "100%",
    },
  },
  cardSkeletonWrapper: {
    border: `1px solid ${colors.lightGrey}`,
    boxShadow: `0px 1px 3px 0px ${colors.shadowGrey}`,
    padding: "12px",
    borderRadius: "20px",
    width: "100%",
    marginBottom: "24px"
  },
  firstPart: {
    display: "flex",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "grid",
      justifyContent: "space-between",
    },
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey
  },
  emptySpace: {
    marginLeft: "12px",
  },
});

export default styles;